"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIALOG_TYPE = void 0;
exports.DIALOG_TYPE = 'DIALOG_TYPE_NPS_SURVEY';
